import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import LandingPage from "@/pages/LandingPage";
import BookingPage from "@/pages/BookingPage";
import BookingConfirmation from "@/pages/BookingConfirmation";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import DriverLogin from "@/pages/DriverLogin";
import DriverDashboard from "@/pages/DriverDashboard";
import DriverApply from "@/pages/DriverApply";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import RiderAuth from "@/pages/RiderAuth";
import MyRides from "@/pages/MyRides";
import CorporatePortal from "@/pages/CorporatePortal";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsAndConditions from "@/pages/TermsAndConditions";
import ContactUs from "@/pages/ContactUs";
import CookieBanner from "@/components/CookieBanner";
import InstallPrompt from "@/components/InstallPrompt";
import { getUser } from "@/lib/api";

const ProtectedRoute = ({ children }) => {
  const user = getUser();
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
};

function App() {
  // Service worker registers once per page load — required by the PWA
  // install prompt and the web-push receiver.
  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    const onLoad = () => {
      navigator.serviceWorker.register("/sw.js").catch(() => {});
    };
    if (document.readyState === "complete") onLoad();
    else window.addEventListener("load", onLoad);
    return () => window.removeEventListener("load", onLoad);
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<RiderAuth mode="login" />} />
          <Route path="/signup" element={<RiderAuth mode="signup" />} />
          <Route path="/my-rides" element={<MyRides />} />
          <Route path="/corporate" element={<CorporatePortal />} />
          <Route path="/book" element={<BookingPage />} />
          <Route path="/book/qr" element={<BookingPage source="qr" />} />
          <Route path="/confirmation/:reference" element={<BookingConfirmation />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/forgot-password" element={<ForgotPassword />} />
          <Route path="/admin/reset-password" element={<ResetPassword />} />
          <Route path="/driver/login" element={<DriverLogin />} />
          <Route path="/driver/apply" element={<DriverApply />} />
          <Route path="/driver" element={<DriverDashboard />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
        {/* CookieBanner uses <Link> to /privacy — MUST live inside BrowserRouter */}
        <CookieBanner />
        <InstallPrompt />
      </BrowserRouter>
      <Toaster theme="dark" richColors position="top-right" />
    </div>
  );
}

export default App;
